export default __webpack_public_path__ + "static/media/wordswarmup_locked_crown.8463777f.svg";